import { usePrivateBoardsList } from '~/components/v2/hooks/queries/usePrivateBoardsList';
import { useFavoriteBoardsParams } from '~/components/v2/hooks/useFavoriteBoardsParams';

export const useFavoriteBoards = () => {
  const { getFavoriteBoardsParams } = useFavoriteBoardsParams();

  return usePrivateBoardsList(getFavoriteBoardsParams());
};
